import { chain } from 'lodash';

const ValidationHelperService = {
  getValidationMessages: (errorDetails, errorMap, defaultMessage = null) => {
    return chain(errorDetails)
      .map('message')
      .filter(code => defaultMessage !== null || errorMap[code] !== undefined)
      .map(code => errorMap[code] ?? defaultMessage)
      .uniq()
      .value();
  }
};

export default ValidationHelperService;
